import { LeadPriority, LeadType } from '@app/models/enums'
import { convertFromMarkup } from '@app/utils/mention'
import { EditorState } from 'draft-js'
import { List, Record } from 'immutable'
import { Attachment, IAttachment } from './Attachment'
import { FeedItem } from './FeedItem'

export interface IFeedItemEditState {
  readonly attachments?: List<IAttachment>
  readonly isPublic: boolean
  readonly leadPriority: LeadPriority
  readonly leadType: LeadType
  readonly markupState: EditorState
  readonly title?: string
}

const FeedItemEditStateRecord = Record({
  attachments: undefined,
  isPublic: false,
  leadPriority: '',
  leadType: '',
  markupState: EditorState.createEmpty(),
  title: undefined,
})

export class FeedItemEditState extends FeedItemEditStateRecord
  implements IFeedItemEditState {
  public static fromFeedItem(feedItem: FeedItem) {
    return new FeedItemEditState({
      attachments: feedItem.attachments,
      isPublic: feedItem.isPublic,
      leadPriority: feedItem.leadPriority,
      leadType: feedItem.leadType,
      markupState: feedItem.markup
        ? EditorState.createWithContent(convertFromMarkup(feedItem.markup))
        : EditorState.createEmpty(),
      title: feedItem.title,
    })
  }

  public static fromJS(initialState?: Partial<IFeedItemEditState>) {
    if (!initialState) {
      return new FeedItemEditState()
    }

    const { attachments, markupState, ...rest } = initialState
    return new FeedItemEditState({
      attachments: attachments
        ? List(attachments.map((a) => Attachment.fromJS(a)))
        : undefined,
      markupState: markupState ? markupState : EditorState.createEmpty(),
      ...rest,
    })
  }

  public readonly attachments?: List<Attachment>
  public readonly isPublic: boolean
  public readonly leadPriority: LeadPriority
  public readonly leadType: LeadType
  public readonly markupState: EditorState
  public readonly title?: string

  constructor(props?: Partial<FeedItemEditState>) {
    props ? super(props) : super()
  }
}
